import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-button-renewed',
  templateUrl: './button-renewed.component.html',
  styleUrls: ['./button-renewed.component.scss']
})
export class ButtonRenewedComponent implements OnInit  {
  @Input() textInput: string;
  @Input() width: string;
  @Input() filterInput: string;

  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter<any>();

  isSelected = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleSelection(): void {
    this.isSelected = !this.isSelected;
    const emitter = this.isSelected ? this.filterInput : '';
    this.onSelectionChange.emit(emitter);
  }

}
